var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"authbar",attrs:{"app":"","absolute":"","tile":""}},[_c('h2',[_c('Brand')],1),_c('v-spacer'),_c('v-btn',{attrs:{"depressed":"","color":"primary","router":"","link":"","to":"/auth"}},[_vm._v(" Log in ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }